<div class="bg-[color:var(--surface-hover)] border border-[color:var(--surface-border)] rounded-[1rem] p-4 flex flex-col justify-between min-h-[160px]">
  <div class="flex items-start justify-between gap-3">
    <span class="summary-card-title" [ngClass]="titleClass">{{ title }}</span>
    <div
      class="flex items-center justify-center text-[color:var(--text-color)] flex-shrink-0"
      [ngStyle]="{ backgroundColor: iconBackground, width: iconSize, height: iconSize, borderRadius: iconBorderRadius, padding: iconPadding }"
    >
      <ng-content select="[summaryCardIcon]"></ng-content>
    </div>
  </div>

  <div class="mt-4">
    <div class="summary-card-value" [ngClass]="valueClass">
      <ng-content select="[summaryCardValue]"></ng-content>
    </div>
    <div class="summary-card-description mt-2" [ngClass]="descriptionClass">
      <ng-content select="[summaryCardDescription]"></ng-content>
    </div>
  </div>
</div>
